import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
// Charts

/* import { ordersChart } from "@/components/Charts/Chart";
import Chart from "chart.js"; */

/* let chart; */
import { getAllSteemLuckNumUserAirDropList } from "../apis/services/steemActivity";
export default {
  data: function data() {
    return {
      type: "",
      luckNumAirDropList: null,
      tableData: null
    };
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllSteemLuckNumUserAirDropList(_this.$route.query.id);

            case 2:
              _this.tableData = _context.sent.data;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};